import { BaseProvider } from '@ethersproject/providers'
import { BigNumberish, Contract, ContractTransaction } from 'ethers'

import { config } from 'configs'
import useContract from './useContract'
import { Knight as AbiKnight } from '../abi'

interface KnightContract extends Contract {
  readonly join: (
    tokenId: BigNumberish,
    stakingAmount: BigNumberish,
    settings: { value: BigNumberish; gasLimit?: BigNumberish }
  ) => Promise<ContractTransaction>

  readonly leave: (
    tokenId: BigNumberish,
    settings?: { gasLimit?: BigNumberish }
  ) => Promise<ContractTransaction>

  readonly queen: (settings?: {
    gasLimit?: BigNumberish
  }) => Promise<ContractTransaction>
}

export default function useKnight(provider: BaseProvider) {
  return useContract(
    provider,
    config('contract.Knight'),
    AbiKnight
  ) as KnightContract | null
}
